import { useStaticQuery, graphql } from "gatsby"

const useCreativeCommunityPartner = () => {
  
  const data = useStaticQuery(graphql`
		query CreativeCommunityQuery {
      eventPartnersCountry : allContentfulEventsHubEventPartnerProfile {
        distinct(field: partnerCountry)
      }
      eventPartnerSpeciality : allContentfulEventsHubEventPartnerProfile {
        distinct(field: partnerSpeciality)
      }
      designStyle : allContentfulCreativeCommunityDesign {
        distinct(field: designStyle)
      }
      eventPartners : allContentfulEventsHubEventPartnerProfile(
        filter: {node_locale: {eq: "en-US"}, partnerType: {eq: "Creative Community"}}
        ) {
        nodes {
          getInTouchButtonLink
          getInTouchButtonText
          instagramProfileLink
          learnMoreText
          partnerDescription {
            partnerDescription
          }
          partnerHeroImages {
            file {
              url
            }
            title
          }
          partnerLocation {
            lat
            lon
          }
          partnerLogo {
            file {
              url
            }
            title
          }
          partnerName
          twitterProfileLink
          websiteLink
          caseStudyButtonLink
          caseStudyButtonText
          facebookProfileLink
          pinterestProfileLink
          partnerSpeciality
          partnerCountry
          createdAt
          contentful_id
          partnerProfileUrlSlug
          partnerType
          communityProfileLink {
            productType
            designTitle
            designType
            designStyle
            designsFiles {
              file {
                url
              }
            }
            designerProfile {
              partnerLogo {
                file {
                  url
                }
              }
              partnerCountry
              partnerName
            }
          }
        }
      }
    }
    `);

  return data;
}

export default useCreativeCommunityPartner;
